import React, { useRef } from 'react'
import { Input } from 'components/ui'
import { HiOutlineSearch } from 'react-icons/hi'
import { useDispatch, useSelector } from 'react-redux'
import { getEmailTemplateList, setTableData } from '../store/dataSlice'
import debounce from 'lodash/debounce'
import cloneDeep from 'lodash/cloneDeep'
import { useTranslation } from 'react-i18next';

const EmailTemplateTableSearch = () => {

	const dispatch = useDispatch()

	const searchInput = useRef()

	const tableData = useSelector((state) => state.emailTemplatesList.data.tableData)

	const debounceFn = debounce(handleDebounceFn, 500)

	function handleDebounceFn(val) {
		const newTableData = cloneDeep(tableData)
		newTableData.query = val
		newTableData.pageIndex = 1
		if(typeof val === 'string' && val.length > 1) {
			fetchData(newTableData)
		}

		if(typeof val === 'string' && val.length === 0) {
			fetchData(newTableData)
		}
	}

	const fetchData = data => {
		dispatch(setTableData(data))
		dispatch(getEmailTemplateList(data))
	}

	const onEdit = (e) => {
		debounceFn(e.target.value)
	}

	const { t } = useTranslation();

	return (
		<Input
			ref={searchInput}
			className="xl:w-52 md:w-full lg:mx-2  lg:w-full md:mb-0 mb-4" 
			size="sm"
			placeholder={t('translation.search')} 
			prefix={<HiOutlineSearch className="text-lg" />} 
			onChange={onEdit}
		/>
	)
}

export default EmailTemplateTableSearch